import React, { useState, useEffect } from "react";
import ForwardPrayerModal from "./ForwardPrayerModal"; // Import the modal
import {
  FaEnvelope,
  FaPhoneSquare,
  FaUser,
  FaExpand,
  FaCompress,
  FaCalendar,
} from "react-icons/fa"; // Import FontAwesome icons
import {
  Button,
  Dropdown,
  Form,
  Card,
  Row,
  Col,
  Pagination,
} from "react-bootstrap";
import MenuBar from "../common/MenuPanel";
import MarianLogo from "../common/MarianLogo"; // Import the MarianLogo component
import FooterPanel from "../common/FooterPanel";
import UtilMethods from "../../util/UtilMethods"; // Import the utility class
import * as XLSX from "xlsx"; // Import XLSX for exporting data
import { useAuth } from "../../auth/AuthContext";

import {
  fetchPrayerRequests,
  updatePrayerReqStatus,
  sendPrayerRequestsReport,
  buildStyledWorkbook,
} from "../../services/PrayerServices";
import {
  PRAYER_REQUEST_CATEGORIES,
  PRAYER_REQUEST_STATUSES,
} from "../common/Constants";
const ListPrayerRequestPage = () => {
  const { user, logout } = useAuth();
  const [prayerRequests, setPrayerRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isActionInProgress, setIsActionInProgress] = useState(false);
  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: "",
    status: "New",
    category: "Prayer",
    actionedBy: "",
  });
  // State to handle the expanded message and review fields
  const [expandedMessages, setExpandedMessages] = useState({});
  const [expandedCardId, setExpandedCardId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;
  const textDisplaySize = 500;
  const toggleCardExpansion = (id) => {
    setExpandedCardId((prevId) => (prevId === id ? null : id));
    toggleMessageExpansion(id);
  };
  const toggleMessageExpansion = (id) => {
    setExpandedMessages((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };
  useEffect(() => {
    if (expandedCardId) {
      setTimeout(() => {
        const expandedElement = document.getElementById(
          `prayer-${expandedCardId}`
        );
        if (expandedElement) {
          expandedElement.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100); // Small delay for Edge rendering
    }
  }, [expandedCardId]);

  const fetchPrayerRequestsData = async () => {
    setLoading(true);
    setError(null);
    setExpandedCardId(null); // Reset expanded card on new fetch
    setExpandedMessages({}); // Reset expanded messages on new fetch
    setSelectedPrayer(null); // Reset selected prayer on new fetch
    setCurrentPage(1); // Reset to first page on new fetch
    try {
      const data = await fetchPrayerRequests(filters);
      if (!data || data.length === 0) {
        setError("No prayer requests found for the selected filters.");
      }
      setPrayerRequests(data);
    } catch (err) {
      console.error("Error fetching prayer requests", err);
      setError("Error fetching prayer requests");
    } finally {
      setLoading(false);
    }
  };
  const [showModal, setShowModal] = useState(false);
  const [selectedPrayer, setSelectedPrayer] = useState(null);

  const handleForward = (prayer, email, message) => {
    console.log(`Forwarding prayer request ${prayer.id} to ${email}`);
    prayer.remark =
      prayer.remark + " Forwarded to " + email + " with message: " + message;
    handleChangeStatus(prayer.id, "Forwarded", email);
  };
  const handleFilterChange = (e) => {
    setFilters((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };
  // save API call and send Reply
  const handleChangeStatus = async (id, newStatus, email) => {
    setIsActionInProgress(true);
    try {
      let updatedPrayerRequest = null;
      if (!user || !user.userID) {
        alert("User is not authenticated.");
        setIsActionInProgress(false);
        return;
      }
      let actionedBy = user.userID || "Admin";
      const prayer = prayerRequests.find((prayer) => prayer.id === id);
      if (
        newStatus === "Actioned" &&
        (!prayer.summary?.trim() || !prayer.replyMessage?.trim())
      ) {
        alert("Summary and Reply are mandatory to mark the Status.");
        setIsActionInProgress(false);
        return;
      }
      if (
        newStatus === "Sent To Marian" &&
        (!prayer.summary?.trim() || !prayer.replyMessage?.trim())
      ) {
        alert("Summary and Reply are mandatory to mark the Status.");
        setIsActionInProgress(false);
        return;
      }
      console.log("Updating prayer request status", {
        id,
        newStatus,
        actionedBy,
      });
      if (newStatus === "Forwarded" && !email) {
        updatedPrayerRequest = await updatePrayerReqStatus(
          prayer,
          prayer.status,
          actionedBy
        );
        console.log("Forwarded prayer request", updatedPrayerRequest);
        setPrayerRequests((prevRequests) =>
          prevRequests.map((prayer) =>
            prayer.id === id ? updatedPrayerRequest : prayer
          )
        );
        // TBD send email
      } else {
        // Call API to update the status
        updatedPrayerRequest = await updatePrayerReqStatus(
          prayer,
          newStatus,
          actionedBy
        );
        // Now update state only if API call is successful
        console.log("Updated prayer request", updatedPrayerRequest);
        setPrayerRequests((prevRequests) =>
          prevRequests.map((prayer) =>
            prayer.id === id ? updatedPrayerRequest : prayer
          )
        );
      }
    } catch (err) {
      console.error("Error updating prayer request status", err);
      setIsActionInProgress(false);
      alert("Error updating prayer request status");
    }
    setIsActionInProgress(false);
  };

  const handleExportToXLS = () => {
    const data = prayerRequests.map((prayer) => ({
      Summary: prayer.summary,
      "Prayer Request": prayer.messageInEnglish,
      Status: prayer.status,
      "Created At": new Date(prayer.createdAt).toLocaleString(),
    }));

    const wb = buildStyledWorkbook(data);

    XLSX.writeFile(wb, "PrayerRequests.xlsx");
  };

  const handleReviewChange = (id, e) => {
    const { name, value } = e.target;
    setPrayerRequests((prevRequests) =>
      prevRequests.map((prayer) =>
        prayer.id === id ? { ...prayer, [name]: value } : prayer
      )
    );
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const paginatedPrayerRequests = prayerRequests.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  useEffect(() => {
    fetchPrayerRequestsData(); // Fetch data only on screen load
  }, []);

  useEffect(() => {
    if (expandedCardId) {
      const expandedElement = document.getElementById(
        `prayer-${expandedCardId}`
      );
      if (expandedElement) {
        expandedElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [expandedCardId]);

  const generateHtmlContent = () => {
    let html = `
<div style="font-family:Arial, sans-serif; font-size:16px; margin-bottom:15px;">
  Praise be to Jesus Christ. Dear Acha,
</div>
<div style="font-family:Arial, sans-serif; font-size:16px; margin-bottom:15px;">
  Below are the prayer needs we received. Kindly pray for these intentions and bless these people.
</div>
<table cellpadding="6" cellspacing="0" style="border-collapse:collapse;width:100%;font-size:14px;font-family:Arial, sans-serif;border:1px solid #000;">
  <thead>
    <tr style="background:#215c98;text-align:left;font-weight:bold;color:#fff;">
      <th style="border:1px solid #000;width:25%;">Name and Contact</th>
      <th style="border:1px solid #000;width:20%;">Summary</th>
      <th style="border:1px solid #000;width:55%;">Details</th>
    </tr>
  </thead>
  <tbody>
    ${
      Array.isArray(prayerRequests)
        ? prayerRequests
            .filter((prayer) => prayer.status === "Actioned" && prayer.summary)
            .map((prayer, index) => {
              const bgColor = index % 2 !== 0 ? "#709fd699" : "#ffffff";
              return `<tr style="background:${bgColor};">
                <td style="border:1px solid #000;vertical-align:top;">
                  <strong>${prayer.firstName || ""} ${
                prayer.lastName || ""
              }</strong><br/>
                  ${prayer.phone || ""}<br/>
                  <a href="mailto:${
                    prayer.email || ""
                  }" style="color:#0563c1;text-decoration:underline;">${
                prayer.email || ""
              }</a>
                </td>
                <td style="border:1px solid #000;vertical-align:top;">${
                  prayer.summary || ""
                }</td>
                <td style="border:1px solid #000;vertical-align:top;">${
                   prayer.messageInEnglish || prayer.message || ""
                }</td>
              </tr>`;
            })
            .join("")
        : ""
    }
  </tbody>
</table>
<div style="font-family:Arial, sans-serif; font-size:16px; margin-top:15px;">
  Thank you, Acha, for your Prayers and support.<br/>
  ${user ? user.firstName : "Admin"}<br/>
  Grace Anointing Team
</div>`;
    return html;
  };

  return (
    <React.Fragment>
      {/* Title Section */}
      <div className="container-fluid p-0 d-flex justify-content-between align-items-center">
        <MarianLogo />
        <h5 className="text-center mb-0">Prayer Requests</h5>
        {user ? (
          <a
            href="/logout"
            className="h6 nav-item nav-link"
            onClick={(e) => {
              e.preventDefault();
              console.log("Logout Menu clicked");
              logout();
            }}
          >
            Logout
          </a>
        ) : (
          <a href="/login" className="nav-item nav-link">
            Login
          </a>
        )}
      </div>
      <div className="container mt-1 mb-1">
        <Form className="mb-1">
          <div className="row g-3">
            {/* From Date Filter */}
            <div className="col-md-2 col-12">
              <Form.Group controlId="fromDate">
                <Form.Control
                  type="date"
                  name="fromDate"
                  value={filters.fromDate}
                  onChange={(e) => handleFilterChange(e)}
                  title="From Date"
                />
              </Form.Group>
            </div>
            {/* To Date Filter */}
            <div className="col-md-2 col-12">
              <Form.Group controlId="toDate">
                <Form.Control
                  type="date"
                  name="toDate"
                  value={filters.toDate}
                  onChange={(e) => handleFilterChange(e)}
                  title="To Date"
                />
              </Form.Group>
            </div>

            {/* Status Filter */}
            <div className="col-md-2 col-12">
              <Form.Group controlId="status">
                <Form.Select
                  as="select"
                  name="status"
                  value={filters.status}
                  onChange={(e) => handleFilterChange(e)}
                  title="Status"
                >
                  {PRAYER_REQUEST_STATUSES.filter(
                    (status) => status.value !== "Blessed"
                  ).map((status) => (
                    <option key={status.value} value={status.value}>
                      {status.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </div>
            {/* Category Filter */}
            <div className="col-md-2 col-12">
              <Form.Group controlId="category">
                <Form.Select
                  as="select"
                  name="category"
                  value={filters.category}
                  onChange={(e) => handleFilterChange(e)}
                  title="Category"
                >
                  <option value="">All</option>
                  {PRAYER_REQUEST_CATEGORIES.map((category) => (
                    <option key={category.value} value={category.value}>
                      {category.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </div>

            {/* Actioned By Filter */}
            <div className="col-md-2 col-12">
              <Form.Group controlId="actionedBy">
                <Form.Control
                  type="text"
                  value={filters.actionedBy}
                  onChange={(e) => handleFilterChange(e)}
                  placeholder="Enter Actioned by ID"
                  title="Actioned By"
                />
              </Form.Group>
            </div>
            {/* Buttons Section */}
            <div className="col-md-2 col-12 d-flex justify-content-end align-items-center">
              <Button
                className="btn btn-primary btn-sm me-2 btn-block"
                onClick={fetchPrayerRequestsData}
              >
                <i className="fas fa-list"></i> List
              </Button>
              <Button
                onClick={handleExportToXLS}
                className="btn btn-success btn-sm btn-block"
                disabled={prayerRequests.length === 0}
              >
                <i className="fas fa-file-excel"></i> Excel
              </Button>
            </div>
          </div>
        </Form>
        {/* Data Loading */}
        {loading && <div className="alert alert-info">Loading...</div>}
        {error && <div className="alert alert-danger">{error}</div>}
        {/* Prayer Requests List with Cards */}
        {!loading && paginatedPrayerRequests.length > 0 && (
          <>
            <Row className="g-4">
              {paginatedPrayerRequests.map((prayer) => (
                <Col
                  key={prayer.id}
                  md={4}
                  lg={6}
                  className={
                    expandedCardId === prayer.id ? "expanded-card" : ""
                  }
                  ref={(el) => {
                    if (expandedCardId === prayer.id && el) {
                      el.scrollIntoView({ behavior: "smooth", block: "start" });
                    }
                  }}
                >
                  <Card id={`prayer-${prayer.id}`}>
                    <Card.Body>
                      {/* User Information */}
                      <Card.Title>
                        <FaUser className="me-2" />
                        {prayer.firstName} {prayer.lastName}
                        <FaCalendar className="ms-3 me-2" />
                        {UtilMethods.formatDateTime(prayer.createdAt)}
                      </Card.Title>
                      <Card.Subtitle className="mb-2 text-muted">
                        <FaEnvelope className="me-2" /> {prayer.email}
                        <FaPhoneSquare className="ms-3 me-2" /> {prayer.phone}
                        <br />
                        Status:
                        <span
                          style={{
                            color:
                              prayer.status === "Actioned"
                                ? "orange"
                                : prayer.status === "Sent to Marian"
                                ? "green"
                                : "inherit",
                          }}
                        >
                          {prayer.status}
                        </span>
                      </Card.Subtitle>
                      {/* Prayer Message - Conditionally Truncated */}
                      <Card.Text>
                        {expandedMessages[prayer.id] ||
                        prayer.messageInEnglish?.length <= textDisplaySize
                          ? prayer.messageInEnglish
                          : `${prayer.messageInEnglish?.slice(
                              0,
                              textDisplaySize
                            )}...`}
                        {expandedCardId === prayer.id &&
                          prayer.language &&
                          prayer.language !== "en" && (
                            <div>
                              <Button
                                variant="link"
                                onClick={() =>
                                  toggleMessageExpansion(
                                    `original-${prayer.id}`
                                  )
                                }
                                className="p-0"
                              >
                                {expandedMessages[`original-${prayer.id}`]
                                  ? "Hide Original"
                                  : "Show Original"}
                              </Button>
                              {expandedMessages[`original-${prayer.id}`] && (
                                <Card.Text className="mt-2">
                                  {prayer.message}
                                </Card.Text>
                              )}
                            </div>
                          )}
                      </Card.Text>
                      {/* Read More / Read Less Button */}
                      {prayer.messageInEnglish?.length > textDisplaySize && (
                        <Button
                          variant="link"
                          onClick={() => {
                            toggleMessageExpansion(prayer.id);
                            if (!expandedMessages[prayer.id]) {
                              document
                                .getElementById(`prayer-${prayer.id}`)
                                .scrollIntoView({
                                  behavior: "smooth",
                                  block: "start",
                                });
                            }
                          }}
                          className="p-0"
                        >
                          {expandedMessages[prayer.id]
                            ? "Read Less"
                            : "Read More"}
                        </Button>
                      )}
                      {/* Expand/Contract Button */}
                      <Button
                        onClick={() => toggleCardExpansion(prayer.id)}
                        className="position-absolute top-0 end-0 m-1 btn-sm btn-info"
                        variant="link"
                        style={{ zIndex: 10 }}
                      >
                        {expandedCardId === prayer.id ? (
                          <FaCompress size={20} />
                        ) : (
                          <FaExpand size={20} />
                        )}
                      </Button>
                      {/* Always Display Summary and Reply Fields */}
                      <Form.Group className="mt-1">
                        <Form.Control
                          as="textarea"
                          rows={expandedCardId === prayer.id ? 3 : 1}
                          name="summary"
                          value={prayer.summary || ""}
                          placeholder="Enter Summary"
                          title="Summary"
                          onChange={(e) => handleReviewChange(prayer.id, e)}
                        />
                      </Form.Group>
                      <Form.Group className="mt-1">
                        <Form.Control
                          as="textarea"
                          rows={expandedCardId === prayer.id ? 4 : 2}
                          name="replyMessage"
                          title="Reply Message"
                          placeholder="Enter Reply Message"
                          value={prayer.replyMessage || ""}
                          onChange={(e) => handleReviewChange(prayer.id, e)}
                        />
                      </Form.Group>
                      {/* Dropdown - Always Visible */}
                      <div className="d-flex justify-content-between mt-1">
                        <Form.Group
                          controlId="category"
                          className="me-2 1 w-50"
                        >
                          <Form.Select
                            name="category"
                            value={prayer.category || ""}
                            onChange={(e) => handleReviewChange(prayer.id, e)}
                            title="Category"
                          >
                            {PRAYER_REQUEST_CATEGORIES.map((category) => (
                              <option
                                key={category.value}
                                value={category.value}
                              >
                                {category.label}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                        <Dropdown>
                          <Dropdown.Toggle
                            variant="success"
                            id="dropdown-basic"
                            disabled={isActionInProgress}
                          >
                            Action
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            {/*<Dropdown.Item
                            onClick={() =>
                              handleChangeStatus(prayer.id, "Pending")
                            }
                          >
                            Pending
                          </Dropdown.Item>*/}
                            <Dropdown.Item
                              disabled={
                                isActionInProgress ||
                                prayer.status === "Sent to Marian"
                              }
                              onClick={() =>
                                handleChangeStatus(prayer.id, "Actioned")
                              }
                            >
                              Actioned
                            </Dropdown.Item>
                            <Dropdown.Item
                              disabled={
                                isActionInProgress ||
                                prayer.status === "Sent to Marian"
                              }
                              onClick={() =>
                                handleChangeStatus(prayer.id, "Sent to Marian")
                              }
                            >
                              Sent to Marian{" "}
                            </Dropdown.Item>
                            <Dropdown.Item
                              disabled={isActionInProgress}
                              onClick={() => {
                                setSelectedPrayer(prayer);
                                setShowModal(true);
                              }}
                            >
                              Forward
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
            <div className="d-flex justify-content-end mt-3">
              <Button
                className="btn btn-warning"
                onClick={async () => {
                  const actionedRequests = prayerRequests.filter(
                    (prayer) =>
                      prayer.status === "Actioned" &&
                      prayer.summary?.trim().length > 0
                  );
                  for (const prayer of actionedRequests) {
                    // or Email to Admin
                    await handleChangeStatus(prayer.id, "Sent to Marian");
                  }
                }}
                disabled={
                  prayerRequests.filter(
                    (prayer) =>
                      prayer.status === "Actioned" && prayer.summary?.trim()
                  ).length === 0
                }
              >
                Send All to Marian
              </Button>
              <Button
                className="btn btn-secondary ms-2"
                onClick={() => {
                  const htmlContent = generateHtmlContent();

                  const popup = window.open(
                    "",
                    "PrayerRequestsHTML",
                    "width=900,height=700,scrollbars=yes"
                  );
                  if (popup) {
                    popup.document.write(`
                      <html>
                        <head>
                          <title>Prayer Requests</title>
                          <meta charset="UTF-8" />
                        </head>
                        <body>${htmlContent}</body>
                      </html>
                    `);
                    popup.document.close();
                  }
                }}
              >
                Generate Summary
              </Button>
              <Button
                className="btn btn-info ms-2"
                onClick={async () => {
                  try {
                    await sendPrayerRequestsReport(prayerRequests);
                    alert("Prayer requests report sent successfully.");
                  } catch (err) {
                    console.error("Error sending prayer requests report", err);
                    alert("Failed to send prayer requests report.");
                  }
                }}
              >
                Send Report
              </Button>
            </div>
          </>
        )}
        {/* Pagination */}
        {!loading && prayerRequests.length > itemsPerPage && (
          <div className="d-flex justify-content-center mt-1">
            <div className="text-center mt-2">
              <small>
                {Math.min(
                  (currentPage - 1) * itemsPerPage + 1,
                  prayerRequests.length
                )}
                –{Math.min(currentPage * itemsPerPage, prayerRequests.length)}{" "}
                of {prayerRequests.length}
              </small>
            </div>

            <div className="d-flex justify-content-center mt-1">
              <Pagination className="pagination">
                {Array.from({
                  length: Math.ceil(prayerRequests.length / itemsPerPage),
                }).map((_, index) => (
                  <Pagination.Item
                    key={index + 1}
                    active={currentPage === index + 1}
                    onClick={() => handlePageChange(index + 1)}
                  >
                    {index + 1}
                  </Pagination.Item>
                ))}
              </Pagination>
            </div>
          </div>
        )}
      </div>

      <ForwardPrayerModal
        title={`${selectedPrayer?.firstName} ${selectedPrayer?.lastName}`}
        show={showModal}
        handleForward={(email, message) =>
          handleForward(selectedPrayer, email, message)
        }
        handleClose={() => setShowModal(false)}
      />
    </React.Fragment>
  );
};
export default ListPrayerRequestPage;
